import { Button } from "@msuite/ui/button";
import { motion } from "motion/react";
import { Icon } from "@msuite/ui/icons";
import { cn } from "@msuite/ui/utils";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import type { PostAskInsightSchema } from "@msuite/utils/schemas";
import type { Disclosure, UseLoading } from "@msuite/ui/hooks";

/** Props Interface */
interface InsightsSpotlightInputProps {
	onSubmit: (values: PostAskInsightSchema) => Promise<void>;
	loader: UseLoading;
	onClose: Disclosure["onClose"];
}

export function InsightsSpotlightInput({ onSubmit, loader, onClose }: InsightsSpotlightInputProps) {
	const methods = useFormContext<PostAskInsightSchema>();
	const formState = useFormState({ control: methods.control });

	/** Render */
	return (
		<form
			className="fixed left-[50%] -translate-x-[50%] bottom-0 h-[15vh] flex flex-col justify-start w-1/2 max-w-[700px]"
			onSubmit={methods.handleSubmit(onSubmit)}
		>
			<motion.div
				className="relative"
				layoutId="spotlight-form"
				initial={{ scale: 0.9, opacity: 0 }}
				animate={{ scale: 1, opacity: 1 }}
				exit={{ scale: 0.8, opacity: 0 }}
			>
				<Controller
					control={methods.control}
					name="question"
					render={({ field }) => (
						<input
							value={field.value}
							onKeyDown={(event) => {
								if (event.key === "Escape") onClose();
							}}
							onChange={field.onChange}
							className={cn("card text-2xl px-8 py-6 rounded-full w-full", "px-[60px]")}
							autoFocus
							placeholder="Was kostet im Schnitt ein Schutzgerüst ?"
						/>
					)}
				/>
				<div className="absolute left-0 w-[60px] flex-center top-0 bottom-0 grayscale">
					<Icon
						name="Astroid"
						size={24}
						strokeWidth={1}
						strokeLinecap="butt"
						className="stroke-accent-500 fill-accent-500/10"
					/>
				</div>
				<div className="absolute right-2 w-[60px] flex-center top-0 bottom-0">
					<Button
						variant="ghost"
						type="submit"
						className="rounded-full"
						isLoading={formState.isSubmitting}
						icon={
							<Icon
								name={loader.isLoading ? "Square" : "SendHorizonal"}
								size={20}
							/>
						}
						size="md"
					/>
				</div>
			</motion.div>
		</form>
	);
}
